import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import {
  getPrevPageArea,
  useGTMEventTracker,
} from '@/hooks/gtm/useGTMEventTracker';
import { GTMEventName } from '@/constant/gtm';
import { getDocumentDetailParam } from '@/utils/gtm/work';
import AIStarDisabledIcon from '@/public/icons/ai-stars-disabled.svg';
import ActionButtonBase from '../ActionButtonBase';
import Image from 'next/image';

export type AiButtonProps = {
  onClick?: () => void;
  buttonClassName?: string;
  disabled?: boolean;
  isGenerating?: boolean; // 정리 생성 중 여부(현재 렌더에는 미사용 — 호출부 전달만 허용)
};

const AiButton = ({
  onClick,
  disabled,
  buttonClassName = 'ai_border',
}: AiButtonProps) => {
  const eventTracker = useGTMEventTracker();
  const { getValues } = useFormContext<RecordFilter>();

  const handleClick = () => {
    onClick?.();

    eventTracker(GTMEventName.clickPostAction, {
      page_area: getPrevPageArea(),
      area_name: '문서',
      action_type: 'AI 정리하기',
      ...getDocumentDetailParam(getValues()),
    });
  };

  const icon = disabled ? (
    <AIStarDisabledIcon />
  ) : (
    <Image
      src="/images/ai-summary-star.png"
      alt=""
      width={24}
      height={24}
      priority
    />
  );

  return (
    <ActionButtonBase
      onClick={handleClick}
      buttonClassName={buttonClassName}
      disabled={disabled}
      icon={icon}
      label="AI Chat"
    />
  );
};

export default AiButton;
